import { FC } from 'react';

import { Retails } from '@telialt/core-retails/src';

import { useBaseProductFromUrlParam } from '../../../hooks/useBaseProductFromUrlParam';

export const ProductRetails: FC = () => {
    const { baseProduct } = useBaseProductFromUrlParam();

    return <Retails baseProductCode={baseProduct.code} />;
};
